package com.imobly.imobly.api.dto

import com.imobly.imobly.domain.Lease
import kotlinx.serialization.Serializable

@Serializable
data class PaginatedLease(
    val leases: List<Lease> = emptyList(),
    val totalPages: Int = 0
)
